import { render, staticRenderFns } from "./ListOrdersParts.vue?vue&type=template&id=212b9c32&"
import script from "./ListOrdersParts.vue?vue&type=script&lang=js&"
export * from "./ListOrdersParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports